import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Booking, AvailableParkings } from '../models/orderModel';
import { Cart } from '../models/CartModel';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  hostPath: string = JSON.parse(environment.IDENTITY);
  cartPath = 'Shuttlebuss/Shuttlebuss.Service/cart';

  constructor(public router: Router, private http: HttpClient) { }

  public addOrder(order: Booking): Observable<Cart> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = `${this.hostPath}${this.cartPath}/addorder/`;
    return this.http
      .post<Cart>(url, order, { headers })
      .pipe(map(result => {
        return result;
      }),
        catchError(this.handleError)
      );
  }

  public getBooking3(organizationId: string, periodFrom: string, periodTo: string, discountCode: string): Observable<Booking> {
    const URL = `${this.hostPath}${this.cartPath}/booking3/${organizationId}/${periodFrom}/${periodTo}/${discountCode}`;
    return this.http.get<Booking>(URL).pipe(
      map(booking => {
        return booking;
      }),
      catchError(this.handleError)
    );
  }

  public getAvailableParkings(organizationId: string, periodFrom: string, periodTo: string, discountCode: string, parkingId?: string, userId?: string): Observable<AvailableParkings> {
    let URL = `${this.hostPath}${this.cartPath}/availableparkings/${organizationId}/${periodFrom}/${periodTo}/${discountCode}`;
    const query: string[] = [];
    if (parkingId) query.push(`parkingId=${parkingId}`);
    if (userId) query.push(`userId=${userId}`);

    if (query.length > 0) {
      URL += `?${query.join("&")}`;
    }

    return this.http.get<AvailableParkings>(URL).pipe(
      map(booking => {
        return booking;
      }),
      catchError(this.handleError)
    );
  }

  public getAvailableParkingsByStation(stationId: string, periodFrom: string, periodTo: string, discountCode?: string): Observable<any> {
    let URL = `${this.hostPath}${this.cartPath}/availableparkingsbystation/${stationId}/${periodFrom}/${periodTo}`;
    if (discountCode && discountCode.trim() !== '' && discountCode.trim().toUpperCase() !== 'NONE') {
      URL += `?discountCode=${encodeURIComponent(discountCode.trim())}`;
    }
    return this.http.get<any>(URL).pipe(
      map(result => result),
      catchError(this.handleError)
    );
  }

  public getAvailableParkingsByStationCriteria(): Observable<any> {
    const URL = `${this.hostPath}${this.cartPath}/availableparkingsbystationcriteria`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<any>(URL, { headers }).pipe(
      map(result => result),
      catchError(this.handleError)
    );
  }


  public getAvailableParkingsOnEdit(orderId: string, periodFrom: string, periodTo: string, discountCode: string, parkingId?: string, userId?: string): Observable<AvailableParkings> {
    let URL = `${this.hostPath}${this.cartPath}/availableparkingsonedit/${orderId}/${periodFrom}/${periodTo}/${discountCode}`;
    const query: string[] = [];
    // if (parkingId) query.push(`parkingId=${parkingId}`);
    // if (userId) query.push(`userId=${userId}`);

    // if (query.length > 0) {
    //   URL += `?${query.join("&")}`;
    // }

    return this.http.get<AvailableParkings>(URL).pipe(
      map(booking => {
        return booking;
      }),
      catchError(this.handleError)
    );
  }

  public setOrderStatusPaid(orderId: string): Observable<any> {
    const url = `${this.hostPath}${this.cartPath}/setorderstatuspaid?orderId=${orderId}`;
    return this.http.get<any>(url).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public sendOrderConf(orderId: string): Observable<any> {
    const url = `${this.hostPath}${this.cartPath}/sendorderconf/${orderId}`;
    return this.http.get<any>(url).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(`cartService.handleError ${errMsg}`);
    return throwError(error);
  }
}
